import {Col, Row, Image, Layout, Typography, Button } from 'antd';
import { Link, } from 'react-router-dom';

import Header from '../../components/Header/Header';
import Footer from  '../../components/Footer/Footer';
import Carousel from  '../../components/Carousel/Carousel';
import myGif from '../../images/IMG_4423.MOV';
import cvFile from '../../files/Mikita.pdf';

const { Paragraph, Title } = Typography;

export default () => {  
    return (
        <Layout >
            <Header />
            <div
                style={{
                    padding: '0 10%',
                }}
            >
                <Row>
                    <Col 
                    style={{
                        padding: '0 1%',
                    }}
                     xl={12}
                     xs={24}
                     >
                        <Title>About Me</Title>
                        <Paragraph style={{ textAlign: 'justify' }}>
                            Hi! My name is Mikita Pemb. Originally from Vitebsk, Belarus. Now living in Gdańsk, Poland. Since 2011 graffiti  has been in my life. My passion, my way of self-expression. 
                        </Paragraph>
                        <Paragraph style={{ textAlign: 'justify' }}>
                            My work is a genuine reflection of my journey: blend of street art (chaos+desire to push boundaries and explore). 
                        </Paragraph>
                        <Paragraph style={{ textAlign: 'justify' }}>
                            I’ve been channeling the energy of the streets straight onto canvases for many years.  In my technique I combine: boldness of spray+versatility of acrylics, using squeezers and markers, adding small details. Every piece I create is a celebration of the style I found on the streets, transformed into something. Not only mixed media, also creating collage using found and improvised materials, creating unique cover designs for music releases and work with the musicians, other artists.
                        </Paragraph>
                        <Paragraph style={{ textAlign: 'justify' }}>
                            Participating in various exhibitions was fun, I love share my unique artistic vision. 
                        </Paragraph>
                        <Paragraph style={{ textAlign: 'justify' }}>
                            My dream is to collaborate with galleries!! My style wants to rise beyond street art, shining!
                        </Paragraph>
                        <Paragraph style={{ textAlign: 'justify' }}>
                            On this platform, you’ll see some of my projects, and I’m happy to share my extra graffiti works with anyone who’s interested. Feel free to reach out, let’s create something together!
                        </Paragraph>
                        <Paragraph style={{ textAlign: 'justify' }}>
                            Art isn’t just something I do - it’s who I am.
                        </Paragraph>
                        <Button type="default">
                            <a href={cvFile}  target="_blank" download="Mikita.pdf">
                                My CV
                            </a>
                        </Button>
                         <video
                            src={myGif} 
                            controls
                            loop
                            muted 
                            style={{ width: '100%',marginTop:"16%" }}
                        />
                    </Col>
                    <Col 
                        xl={12}
                        xs={24}
                        >
                        <Carousel />
                    </Col>
                </Row>
            </div>
            <Footer />
        </Layout>
    )
}

// cсылки на блог